<template>
  <v-container fluid>
    
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">使用明細查詢</v-toolbar-title>
      </div>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物使用明細</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{overview_total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="usageList"
        :headers="headers"
        hide-default-header
        :loading="isUsageLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in headers"
              :key="header.value"
              class="tableTD"
              @click="choseDevice(item)"
            >
              <div>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>

      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">使用日期(起)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchStartDateMenu"
              v-model="searchStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchStartDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchStartDate"
                @input="searchStartDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">使用日期(迄)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchEndDateMenu"
              v-model="searchEndDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchEndDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchEndDate"
                @input="searchEndDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchSiteId"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">標的物名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchSiteNm"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">設備使用明細</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="devicePage"
            :length="devicePageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{device_total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="deviceRows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="deviceUsageList"
        :headers="deviceHeaders"
        hide-default-header
        :loading="isDeviceLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in deviceHeaders"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in deviceHeaders"
              :key="header.value"
              class="tableTD"
            >
              <div>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Usage_Record_View',
  data: () => ({
    headers: [
      { text: '標的物編號', value: 'site_id', sortable: false },
      { text: '標的物名稱', value: 'site_nm', sortable: false },
      { text: '使用日期', value: 'date',  sortable: false }
    ],
    deviceHeaders: [
      { text: '設備編號	', value: 'device_id', sortable: false },
      { text: '設備名稱', value: 'device_nm', sortable: false },
    ],
    searchStartDateMenu: false,
    searchStartDate: '',
    searchEndDateMenu: false,
    searchEndDate: '',
    searchSiteId: '',
    searchSiteNm: '',
    searchDate: '',
    searchDeviceSiteId: '',
    rows: 10,
    deviceRows: 10,
    sortItem: 'site_id',
    sortOrder: true,
    overview_total: 0,
    device_total: 0,
    pageCount: 0,
    devicePageCount: 0,
    page: 1,
    devicePage: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    usageList: [],
    deviceUsageList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    isUsageLoading: false,
    isDeviceLoading: false,
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.setDefultDate()
  },
  watch: {
    page () {
      this.getPageData()
    },
    devicePage () {
      this.getDeviceDetail()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    searchStartDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchEndDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteNm () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    deviceRows () {
      this.devicePage === 1 ? this.getDeviceDetail() : this.devicePage = 1
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    setDefultDate () {
      var d = new Date()
      var endDate = d.getFullYear()
      if ((d.getMonth() + 1) < 10) {
        endDate = endDate + '-0' + (d.getMonth() + 1)
      } else {
        endDate = endDate + '-' + (d.getMonth() + 1)
      }
      if ((d.getDate()) < 10) {
        endDate = endDate + '-0' + (d.getDate())
      } else {
        endDate = endDate + '-' + (d.getDate())
      }
      this.searchStartDate = this.searchEndDate = endDate
    },
    getPageData () {
      this.isUsageLoading = true
      this.usageList = []
      var searchStartDate = {
        name: 'create_dt',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'create_dt',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteNm = {
        name: 'site_nm',
        value: this.searchSiteNm,
        displayType: 'like'
      }
      var wheres = [searchStartDate, searchEndDate, searchSiteId, searchSiteNm]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: 'asc',
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'usage_record_view/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.overview_total = response.data.total
            this.pageCount = Math.ceil(this.overview_total / this.rows)
            this.usageList = response.data.rows
            this.usageList.forEach(element => {
              element.date = element.date.split(' ')[0]
            })
          }
        })
      .finally(() => {
        this.isUsageLoading = false
      })
    },
    choseDevice (item) {
      this.searchDate = item.date
      this.searchDeviceSiteId = item.site_id
      this.getDeviceDetail()
    },
    getDeviceDetail () {
      this.isDeviceLoading = true
      this.deviceUsageList = []
      var searchDate = {
        name: 'date',
        value: this.searchDate,
        displayType: '='
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchDeviceSiteId,
        displayType: '='
      }
      var wheres = [searchDate, searchSiteId]
      var parm = {
        page: this.devicePage,
        rows: this.deviceRows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'usage_record_device_view/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.device_total = response.data.total
            this.devicePageCount = Math.ceil(this.device_total / this.deviceRows)
            this.deviceUsageList = response.data.rows
          }
        })
      .finally(() => {
        this.isDeviceLoading = false
      })
    }
  }
}
</script>
